module.exports = __webpack_public_path__ + "static/peter-c78d0a003f68d11e15291dd07a18f956.jpg";